export default __webpack_public_path__ + "static/media/logo.f63bf472.png";